import React from 'react';
import {useTranslation} from 'react-i18next';
import Select from "./Select";

const ShippingTypeSelector = ({value, setValue, disabled, required}) => {
    const {t} = useTranslation();

    return <Select
        label={t('product_shipping_type')}
        helperText={t('product_shipping_type_helperText')}
        value={value}
        onChange={e => setValue(e.target.value)}
        optionKey='Key'
        optionValue='Value'
        options={[
            {Key: 'package', Value: t('product_shipping_type_package')},
            {Key: 'letter', Value: t('product_shipping_type_letter')},
            {Key: 'cool', Value: t('product_shipping_type_cool')},
            {Key: 'freeze', Value: t('product_shipping_type_freeze')},
        ]}
        inputProps={{
            native: true,
            disabled: disabled,
            variant: 'outlined',
            fullWidth: true,
            required: required
        }}
    />;
};

export default ShippingTypeSelector;